export const styles = () => ({
  container: {
    padding: '55px 48px 120px 24px',
    borderRight: '1px solid rgba(53, 64, 82, 0.1)',
    width: 'calc(100% - 398px)',
    cursor: 'pointer',
  },
})
